export interface SecondaryCardHeaderProps {
  label: string;
  children?: React.ReactNode;
}
export const SecondaryCardHeader: React.FC<SecondaryCardHeaderProps> = (
  props
) => {
  return (
    <div className="relativity-subcard-header">
      <h4 className="bp5-heading">{props.label}</h4>
      {props.children}
    </div>
  );
};

export default SecondaryCardHeader;
